import { createContext, Ref } from "react";

const initialValue: {
  wrapperRef: HTMLDivElement | null;
} = {
  wrapperRef: null,
};

export const LayoutContext = createContext(initialValue);
